<template>
  <div class="ai rt60">
    <div>
      <!-- <banner :child-data="fdata"></banner> -->
      <div style="height:650px;overflow:hidden"
           class="mainTop"
           :style="{ height: Mobile + 'px'}">
        <img v-if="!showMobile"
             src="img/Ai/人体分析.jpg"
             alt=""
             class="mobile"
             style="height:100%;position: relative;"
             :style="{ height: Mobile + 'px'}">
        <img v-if="showMobile"
             src="img/Ai/Pmobile.jpg"
             alt=""
             class="mobile"
             style="position: relative;"
             :style="{ height: Mobile + 'px'}">
      </div>

      <div id="ai-main">
        <div>
          <div class="ai-sec container"
               data-ani>
            <div class="develop-title">
              <span class="line"></span>
              <span class="title-text">{{$t('Function')}}</span>
              <span class="line"></span>
            </div>
            <b-button-group>
              <b-button @click="addActive('human')"
                        :class="menu=='human'?'active':''"
                        variant="outline-primary">{{$t('homenavBT0')}}</b-button>
              <b-button @click="addActive('re-id')"
                        :class="menu=='re-id'?'active':''"
                        variant="outline-primary">{{$t('homenavBT1')}}</b-button>
              <b-button @click="addActive('gesture')"
                        :class="menu=='gesture'?'active':''"
                        variant="outline-primary">{{$t('homenavBT2')}}</b-button>
              <b-button @click="addActive('pose')"
                        :class="menu=='pose'?'active':''"
                        variant="outline-primary">{{$t('homenavBT3')}}</b-button>

            </b-button-group>
            <!-- <div>
            <img src="/img/working.jpg" alt="">
            <h6 style="margin-top:12px">功能正在开发中, 敬请期待</h6>
            </div> -->

            <!-- 人脸检测与分析 -->
            <!-- <div class="imgGroup" v-show="menu=='human'">
              <img ref="dehu0" class="m1h1" @click="getFile($event,0)" src="../../public/img/Ai/example/f-1.jpg" alt />
              <img class="m1h1" @click="getFile($event,0)" src="../../public/img/Ai/example/f-3.jpg" alt />
              <img class="m1h1" @click="getFile($event,0)" src="../../public/img/Ai/example/f-5.jpg" alt />
              <img class="m1h1" @click="getFile($event,0)" src="../../public/img/Ai/example/f-6.jpg" alt />
              <img class="m1h1" @click="getFile($event,0)" src="../../public/img/Ai/example/f-8.jpg" alt />
              <img class="m1h1" @click="getFile($event,0)" src="../../public/img/Ai/example/f-11.jpg" alt />
              <img class="m1h1" @click="getFile($event,0)" src="../../public/img/Ai/example/f-13.jpg" alt />
            </div> -->

            <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img ref="img0"
                   class="m1h1"
                   @click="getFile($event,0)"
                   src="../../public/img/Ai/example/walk.jpg"
                   alt />
            </div>

            <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img ref="img1"
                   class="m1h1"
                   @click="getFile($event,1)"
                   src="../../public/img/Ai/example/track.jpg"
                   alt />
            </div>

            <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img ref="img2"
                   class="m1h1"
                   @click="getFile($event,2)"
                   src="../../public/img/Ai/example/bone.jpg"
                   alt />
            </div>

            <div class="imgGroup"
                 v-show="menu=='noshow'">
              <img ref="img3"
                   class="m1h1"
                   @click="getFile($event,3)"
                   src="../../public/img/Ai/example/pose.jpg"
                   alt />
            </div>

            <!-- <div class="imgGroup" v-show="menu=='noshow'">
              <img ref="img3" class="m1h1" @click="getFile($event,1)" src="../../public/img/Ai/example/track.jpg" alt />
            </div> -->

            <!-- <div class="imgGroup" v-show="menu=='re-id'">
              <img ref="dere0" class="m1h1" @click="getFile($event,1)" src="../../public/img/Ai/example/f-1.jpg" alt />
              <img class="m1h1" @click="getFile($event,1)" src="../../public/img/Ai/example/f-3.jpg" alt />
              <img class="m1h1" @click="getFile($event,1)" src="../../public/img/Ai/example/f-5.jpg" alt />
              <img class="m1h1" @click="getFile($event,1)" src="../../public/img/Ai/example/f-6.jpg" alt />
              <img class="m1h1" @click="getFile($event,1)" src="../../public/img/Ai/example/f-8.jpg" alt />
              <img class="m1h1" @click="getFile($event,1)" src="../../public/img/Ai/example/f-11.jpg" alt />
              <img class="m1h1" @click="getFile($event,1)" src="../../public/img/Ai/example/f-13.jpg" alt />
            </div> -->

            <!-- <div class="imgGroup" v-show="menu=='gesture'">
              <img ref="dege0" class="m1h1" @click="getFile($event,2)" src="../../public/img/Ai/example/f-1.jpg" alt />
              <img class="m1h1" @click="getFile($event,2)" src="../../public/img/Ai/example/f-3.jpg" alt />
              <img class="m1h1" @click="getFile($event,2)" src="../../public/img/Ai/example/f-5.jpg" alt />
              <img class="m1h1" @click="getFile($event,2)" src="../../public/img/Ai/example/f-6.jpg" alt />
              <img class="m1h1" @click="getFile($event,2)" src="../../public/img/Ai/example/f-8.jpg" alt />
              <img class="m1h1" @click="getFile($event,2)" src="../../public/img/Ai/example/f-11.jpg" alt />
              <img class="m1h1" @click="getFile($event,2)" src="../../public/img/Ai/example/f-13.jpg" alt />
            </div> -->

            <!-- <div class="imgGroup" v-show="menu=='pose'">
              <img ref="depo0" class="m1h1" @click="getFile($event,3)" src="../../public/img/Ai/example/f-1.jpg" alt />
              <img class="m1h1" @click="getFile($event,3)" src="../../public/img/Ai/example/f-3.jpg" alt />
              <img class="m1h1" @click="getFile($event,3)" src="../../public/img/Ai/example/f-5.jpg" alt />
              <img class="m1h1" @click="getFile($event,3)" src="../../public/img/Ai/example/f-6.jpg" alt />
              <img class="m1h1" @click="getFile($event,3)" src="../../public/img/Ai/example/f-8.jpg" alt />
              <img class="m1h1" @click="getFile($event,3)" src="../../public/img/Ai/example/f-11.jpg" alt />
              <img class="m1h1" @click="getFile($event,3)" src="../../public/img/Ai/example/f-13.jpg" alt />
            </div> -->

            <div class="fileGroup"
                 v-show="menu=='human'">
              <div class="imgLeft">
                <div class="tips">原始图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <div :class="{imgline: pictLoading}"></div>
                    <img :src="img0" />
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(0)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         @change="addImg($event,0)"
                         src="../"
                         ref="inputer0"
                         id="file1"
                         accept="image/png, image/jpeg, image/gif, image/jpg" />
                </div>
              </div>
              <div class="json_right" v-loading="pictLoading"
                   element-loading-background="rgba(255, 255, 255, 0.5)"
                   element-loading-text="正在识别">
                <div class="tips">RESPONSE JSON</div>
                <div class="responseTips">
                  <pre>{{msg0}}</pre>
                </div>
              </div>
            </div>
            <div class="fileGroup"
                 v-show="menu=='re-id'">
              <div class="imgLeft">
                <div class="tips">原始图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <div :class="{imgline: pictLoading}"></div>
                    <img :src="img1">
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(1)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         @change="addImg($event,1)"
                         ref="inputer1"
                         id="file1"
                         accept="image/png, image/jpeg, image/gif, image/jpg">
                </div>
              </div>
              <div class="json_right" v-loading="pictLoading"
                   element-loading-background="rgba(255, 255, 255, 0.5)"
                   element-loading-text="正在识别">
                <div class="tips">RESPONSE JSON</div>
                <div class="responseTips">
                  <pre>{{msg1}}</pre>
                </div>
              </div>
            </div>
            <div class="fileGroup"
                 v-show="menu=='gesture'">
              <div class="imgLeft">
                <div class="tips">原始图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <div :class="{imgline: pictLoading}"></div>
                    <img :src="img2">
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(2)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         @change="addImg($event,2)"
                         ref="inputer2"
                         id="file2"
                         accept="image/png, image/jpeg, image/gif, image/jpg">
                </div>
              </div>
              <div class="json_right" v-loading="pictLoading"
                   element-loading-background="rgba(255, 255, 255, 0.5)"
                   element-loading-text="正在识别">
                <div class="tips">RESPONSE JSON</div>
                <div class="responseTips">
                  <pre>{{msg2}}</pre>
                </div>
              </div>
            </div>
            <div class="fileGroup"
                 v-show="menu=='pose'">
              <div class="imgLeft">
                <div class="tips">原始图片</div>
                <div class="imgShow">
                  <li class="imgSec">
                    <div :class="{imgline: pictLoading}"></div>
                    <img :src="img3">
                  </li>
                </div>
                <div class="imgBottom">
                  <b-button variant="outline-primary"
                            @click="triggerFile(3)">本地上传</b-button>
                  <input type="file"
                         class="upload"
                         @change="addImg($event,3)"
                         ref="inputer3"
                         id="file3"
                         accept="image/png, image/jpeg, image/gif, image/jpg">
                </div>
              </div>
              <div class="json_right" v-loading="pictLoading"
                   element-loading-background="rgba(255, 255, 255, 0.5)"
                   element-loading-text="正在识别">
                <div class="tips">RESPONSE JSON</div>
                <div class="responseTips">
                  <pre>{{msg3}}</pre>
                </div>
              </div>
            </div>
          </div>
          <div class="ai-advantage"
               data-ani>
            <div class="container">
              <div class="develop-title">
                <span class="line"></span>
                <span class="title-text">{{$t('Feature')}}</span>
                <span class="line"></span>
              </div>
              <b-card-group deck>
                <b-card>
                  <i class="card-img-top myicon icon0"></i>
                  <b-card-text>
                    <h4>{{$t('BFeatureT0')}}</h4>
                    <p>{{$t('BFeatureTP0')}}</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="card-img-top myicon icon1"></i>
                  <b-card-text>
                    <h4>{{$t('BFeatureT1')}}</h4>
                    <p>{{$t('BFeatureTP1')}}</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="card-img-top myicon icon2"></i>
                  <b-card-text>
                    <h4>{{$t('BFeatureT2')}}</h4>
                    <p>{{$t('BFeatureTP2')}}</p>
                  </b-card-text>
                </b-card>
              </b-card-group>
              <b-card-group deck>
                <b-card>
                  <i class="card-img-top myicon icon3"></i>
                  <b-card-text>
                    <h4>{{$t('BFeatureT3')}}</h4>
                    <p>{{$t('BFeatureTP3')}}</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="card-img-top myicon icon4"></i>
                  <b-card-text>
                    <h4>{{$t('BFeatureT4')}}</h4>
                    <p>{{$t('BFeatureTP4')}}</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="card-img-top myicon icon5"></i>
                  <b-card-text>
                    <h4>{{$t('BFeatureT5')}}</h4>
                    <p>{{$t('BFeatureTP5')}}</p>
                  </b-card-text>
                </b-card>
              </b-card-group>
            </div>
          </div>
          <div class="ai-scene"
               data-ani>
            <div class="container">
              <div class="develop-title">
                <span class="line"></span>
                <span class="title-text">{{$t('Scenario')}}</span>
                <span class="line"></span>
              </div>
              <b-card-group deck>
                <b-card>
                  <i class="Card image myleftIcon icon0"></i>
                  <b-card-text>
                    <h4>{{$t('BScenarioT0')}}</h4>
                    <p>{{$t('BScenarioTP0')}}</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="Card image myleftIcon icon1"></i>
                  <b-card-text>
                    <h4>{{$t('BScenarioT1')}}</h4>
                    <p>{{$t('BScenarioTP1')}}</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="Card image myleftIcon icon2"></i>
                  <b-card-text>
                    <h4>{{$t('BScenarioT2')}}</h4>
                    <p>{{$t('BScenarioTP2')}}</p>
                  </b-card-text>
                </b-card>
              </b-card-group>
            </div>
          </div>
          <!-- <div class="ai-parter" data-ani>
            <div class="container">
              <div class="develop-title">
                <span class="line"></span>
                <span class="title-text">{{$t('Application')}}</span>
                <span class="line"></span>
              </div>
              <div class="partner-sec">
                <b-row>
                  <b-col cols="6" md="4" lg="3">
                    <div class="container">
                      <b-img fluid src="img/Ai/1.png" alt="Image 1"></b-img>
                    </div>
                  </b-col>
                  <b-col cols="6" md="4" lg="3">
                    <div class="container">
                      <b-img fluid src="img/Ai/9.png" alt="Image 1"></b-img>
                    </div>
                  </b-col>
                  <b-col cols="6" md="4" lg="3">
                    <div class="container">
                      <b-img fluid src="img/Ai/11.png" alt="Image 1"></b-img>
                    </div>
                  </b-col>
                  <b-col cols="6" md="4" lg="3">
                    <div class="container">
                      <b-img fluid src="img/Ai/4.png" alt="Image 1"></b-img>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topNav from '../components/top'
import banner from '../components/banner'
import footerBot from '../components/footerBot'
import { mapMutations } from 'vuex'
import Axios from 'axios'
export default {
  name: 'about',
  data() {
    return {
      fdata: {
        h1: 'homenavBT',
        h2:
          '提供 6 种在线/离线活体检测服务，识别业务场景中的用户是否为「真人」，有效抵御照片、视频、3D模具等作弊行为，保障业务安全性',
        style: {
          background: '#0052d9'
        },
        myheaderstyle: {
          display: 'flex',
          'justify-content': 'space-around'
        },
        imgurl: '../../img/Ai/人体识别.jpg'
      },
      formData: new FormData(),
      screenWidth: document.body.clientWidth,
      showMobile: false,
      Mobile: 650,
      pictLoading: true,
      img0: {},
      img1: {},
      img2: {},
      img3: {},
      img4: {},
      img5: {},
      img6: {},
      img7: {},
      menu: 'human',
      fil: '',
      imgLen: 0
    }
  },
  components: {
    topNav,
    banner,
    footerBot
  },
  methods: {
    addActive(val) {
      this.menu = val
    },
    formatJson(json, options) {
      var reg = null,
        formatted = '',
        pad = 0,
        PADDING = '    ' // one can also use '\t' or a different number of spaces
      // optional settings
      options = options || {}
      // remove newline where '{' or '[' follows ':'
      options.newlineAfterColonIfBeforeBraceOrBracket =
        options.newlineAfterColonIfBeforeBraceOrBracket === true ? true : false
      // use a space after a colon
      options.spaceAfterColon = options.spaceAfterColon === false ? false : true

      // begin formatting...

      // make sure we start with the JSON as a string
      if (typeof json !== 'string') {
        json = JSON.stringify(json)
      }
      // parse and stringify in order to remove extra whitespace
      json = JSON.parse(json)
      json = JSON.stringify(json)

      // add newline before and after curly braces
      reg = /([\{\}])/g
      json = json.replace(reg, '\r\n$1\r\n')

      // add newline before and after square brackets
      reg = /([\[\]])/g
      json = json.replace(reg, '\r\n$1\r\n')

      // add newline after comma
      reg = /(\,)/g
      json = json.replace(reg, '$1\r\n')

      // remove multiple newlines
      reg = /(\r\n\r\n)/g
      json = json.replace(reg, '\r\n')

      // remove newlines before commas
      reg = /\r\n\,/g
      json = json.replace(reg, ',')

      // optional formatting...
      if (!options.newlineAfterColonIfBeforeBraceOrBracket) {
        reg = /\:\r\n\{/g
        json = json.replace(reg, ':{')
        reg = /\:\r\n\[/g
        json = json.replace(reg, ':[')
      }
      if (options.spaceAfterColon) {
        reg = /\:/g
        json = json.replace(reg, ': ')
      }

      $.each(json.split('\r\n'), function(index, node) {
        var i = 0,
          indent = 0,
          padding = ''

        if (node.match(/\{$/) || node.match(/\[$/)) {
          indent = 1
        } else if (node.match(/\}/) || node.match(/\]/)) {
          if (pad !== 0) {
            pad -= 1
          }
        } else {
          indent = 0
        }

        for (i = 0; i < pad; i++) {
          padding += PADDING
        }

        formatted += padding + node + '\r\n'
        pad += indent
      })

      return formatted
    },
    getResult(url, formdata, ele, type, num, formdata2) {
      this.pictLoading = true
      this[ele] = ''
      let res1 = new Promise((resolve, reject) => {
        Axios({
          method: 'post',
          url,
          data: this.$qs.stringify(formdata)
        })
          .then(res => {
            resolve(res)
          })
          .catch(rej => {
            reject(rej)
          })
      })
      let res2 = new Promise((resolve, reject) => {
        formdata.ret = 'image'
        Axios({
          method: 'post',
          url,
          responseType: 'arraybuffer',
          data: this.$qs.stringify(formdata2)
        })
          .then(res => {
            resolve(res)
          })
          .catch(rej => {
            reject(rej)
          })
      })
      Promise.all([res1, res2]).then(res => {
        this.pictLoading = false
        //   res.for
        if (ele == 'msgcompare' || ele == 'msgcompare2') {
          this[ele] = '相似度: ' + (res[0].data.data * 100).toFixed(2) + '%'
          this.pictLoading = false
        } else {
          this[ele] = this.formatJson(res[0].data)
        }
        this['img' + num] =
          'data:image/png;base64,' +
          btoa(
            new Uint8Array(res[1].data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ''
            )
          )
      })
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    getFile(event, val) {
      console.log(event.target.src)
      var image = new Image()
      console.log(image)
      this['img' + val] = event.target.src
      image.crossOrigin = ''
      image.src = event.target.src
      var that = this
      image.onload = function() {
        var base64 = that.getBase64Image(image)
        if (base64.split(',')[0].indexOf('base64') >= 0) {
          document.getElementById('file' + val).value = ''
          base64 = base64.split(',')[1]
          if (val == 0) {
            that.getResult(
              // https://ai.neuapi.com/ai/
              'https://ai.neuapi.com/v1/face_detect',
              {
                image_type: 'BASE64',
                image: base64
              },
              'msg0'
            )
          } else if (val == 1) {
            // that.getResult(
            //   "https://ai.neuapi.com/v1/face_attribute",
            //   {
            //     image_type: "BASE64",
            //     image: base64
            //   },
            //   "msg1"
            // );
          } else if (val == 2) {
            that.getResult(
              'https://ai.neuapi.com/v1/body_pose',
              {
                image_type: 'BASE64',
                image: base64
              },
              'msg2'
            )
          } else if (val == 3) {
            that.getResult(
              'https://ai.neuapi.com/v1/gesture_recognize',
              {
                image_type: 'BASE64',
                image: base64
              },
              'msg3',
              'gesture_recognize',
              val,
              {
                image_type: 'BASE64',
                image: base64,
                ret: 'image'
              }
            )
          }
        }
      }
    },
    getBase64Image(img) {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, img.width, img.height)
      var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
      var dataURL = canvas.toDataURL('image/' + ext)
      return dataURL
    },
    triggerFile(val) {
      var myfile = document.getElementById('file' + val)
      myfile.click()
    },
    addImg(event, val) {
      console.log(event.target.files[0])
      var inputDOM = event.target.files[0]
      var reader = new FileReader()
      var that = this
      reader.readAsDataURL(inputDOM)
      reader.onload = function(e) {
        that['img' + val] = this.result
        console.log(that['img' + val])
        let img = new Image()
        img.src = this.result
        var otherthat = that
        img.onload = function() {
          otherthat.oldimgHeight = 300 / img.height
        }
        var baseUrl = this.result
        if (baseUrl.split(',')[0].indexOf('base64') >= 0) {
          baseUrl = baseUrl.split(',')[1]
          if (val == 0) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_detect',
              {
                image_type: 'BASE64',
                image: baseUrl
              },
              'msg0',
              'face_detect',
              val,
              {
                image_type: 'BASE64',
                image: baseUrl,
                ret: 'image'
              }
            )
          } else if (val == 1) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_detect',
              {
                image_type: 'BASE64',
                image: baseUrl
              },
              'msg1',
              'face_detect',
              val,
              {
                image_type: 'BASE64',
                image: baseUrl,
                ret: 'image'
              }
            )
          } else if (val == 3) {
            that.getResult(
              'https://ai.neuapi.com/v1/gesture_recognize',
              {
                image_type: 'BASE64',
                image: baseUrl
              },
              'msg3',
              'gesture_recognize',
              val,
              {
                image_type: 'BASE64',
                image: baseUrl,
                ret: 'image'
              }
            )
          } else if (val == 2) {
            that.getResult(
              'https://ai.neuapi.com/v1/face_attribute',
              {
                image_type: 'BASE64',
                image: baseUrl
              },
              'msg2',
              'face_attribute',
              val,
              {
                image_type: 'BASE64',
                image: baseUrl,
                ret: 'image'
              }
            )
          }
        }
      }
    },
    ...mapMutations(['editMenu'])
  },
  mounted() {
    if (this.screenWidth < 480 || this.screenWidth === 480) {
      this.showMobile = true
      this.Mobile = window.screen.height
    }
    this.editMenu('about')
    this.$refs.img0.click()
    this.$refs.img1.click()
    this.$refs.img2.click()
    this.$refs.img3.click()
    // this.$refs.dehu0.click();
    // this.$refs.depo0.click();
    // this.$refs.dere0.click();
    // this.$refs.dege0.click();
  },
  watch: {
    $route(to, from) {
      if (to.query.id) {
        this.menu = to.query.id
      } else {
        this.menu = 'human'
      }
    }
  }
}
</script>

<style scoped>
.m1h1 {
  width: 100px;
  height: 100px;
}
.myicon {
  width: 80px;
  height: 80px;
}
#headerwrap h2 {
  font-size: 20px;
  text-align: left;
}
blockquote {
  border: none;
}
#navbar-main {
  /* height: 144px; */
}
#about-main {
  padding-bottom: 30px;
}
#headerwrap {
  /* background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center top; */
  display: flex;
  align-items: center;
  justify-content: center;
}
#headerwrap h1 {
  margin-top: 0;
}

#headerwrap h2 {
  color: white;
  margin-bottom: 0;
}

#ai-main .img-banner {
  height: 380px;
  width: 100%;
  /* background: url(img/about/gyks_banner@3x.jpg) no-repeat 100% center; */
  background-size: 100% 100%;
  box-sizing: border-box;
}

#ai-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}

@media screen and (max-width: 480px) {
  #ai-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center;
    background-size: 100% 100%;
  }
  .mobile {
    width: auto !important;
    height: 100% !important;
  }
}
#ai-main .company-info {
  /* padding: 20px 0px; */
  box-sizing: border-box;
}
.company-develop {
  padding-top: 40px;
}
#ai-main .info-title,
#ai-main .develop-title {
  text-align: center;
  margin-bottom: 56px;
  margin-top: 20px;
}
#ai-main .info-main {
  display: flex;
  flex-direction: column;
  /* align-items: ; */
}
#ai-main .info-title .title-text,
#ai-main .develop-title .title-text {
  font-size: 30px;
}

.tab-content {
  background-color: #fff;
  border: 1px solid #ddd;
  border-top: 0;
  padding: 15px 15px 5px;
  box-sizing: border-box;
}

.well {
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0.05);
}

#headerwrap p {
  font-weight: 300;
  text-align: center;
  letter-spacing: 1px;
}
.btn-outline-primary {
  color: black;
  border-color: #ccc;
}
.btn-outline-primary:hover {
  color: white;
}
.ai-advantage {
  background: rgb(245, 245, 245);
  padding: 60px 0px 60px;
}
.ai-advantage .card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: space-between; */
}
.ai-advantage .card-body .myicon {
  /* background-image: url(../../public/img/allicon.png); */
  /* background-position: 0 -256px;*/
  margin-bottom: 20px;
}

.ai-advantage .card-body .myicon.icon0 {
  background-image: url(../../public/img/Ai/body/data.png);
}
.ai-advantage .card-body .myicon.icon1 {
  background-image: url(../../public/img/Ai/body/fast.png);
}
.ai-advantage .card-body .myicon.icon2 {
  background-image: url(../../public/img/Ai/body/improve.png);
}
.ai-advantage .card-body .myicon.icon3 {
  background-image: url(../../public/img/Ai/body/remove.png);
}
.ai-advantage .card-body .myicon.icon4 {
  background-image: url(../../public/img/Ai/body/rate.png);
}
.ai-advantage .card-body .myicon.icon5 {
  background-image: url(../../public/img/Ai/body/customize.png);
}
.card-deck:nth-child(n + 1) {
  margin-top: 30px;
}
.card-text p {
  text-align: left;
}
.card {
  border: none;
  background: unset;
}
.ai-scene {
  padding: 60px 0;
}
.ai-scene .card {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ai-advantage .card .card-body h4 {
  text-align: center;
}

.ai-scene .card .card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
}
.ai-scene .card .card-body .card-text {
  flex: 1;
}
.ai-scene .card .card-body .card-text h4 {
  font-size: 18px;
}
.ai-scene .card .card-body .card-text p {
  font-size: 14px;
}
.ai-scene .card .card-body .myleftIcon {
  /* background-image: url(../../public/img/allicon.png); */
  /* background-position: -269px -340px; */
  width: 56px;
  height: 56px;
  display: block;
  margin-right: 20px;
}
.ai-scene .card .card-body .myleftIcon.icon0 {
  background-image: url(../../public/img/Ai/body/count.png);
}
.ai-scene .card .card-body .myleftIcon.icon1 {
  background-image: url(../../public/img/Ai/body/action.png);
}
.ai-scene .card .card-body .myleftIcon.icon2 {
  background-image: url(../../public/img/Ai/body/pose.png);
}

.ai-scene .card img {
  width: 50%;
}

.ai-parter {
  background: rgb(245, 245, 245);
  padding: 60px 0;
}
.partner-sec {
  display: flex;
  align-items: center;
  justify-content: center;
}
.partner-sec .col-6 {
  margin-bottom: 20px;
}
.partner-sec > div {
  padding: 20px;
  flex: 1;
}
.partner-sec .container {
  padding: 10px;
  width: 100%;
  background-color: white;
  border-radius: 6px;
}
.partner-sec img {
  width: 80%;
}
.ai-parter .develop-title .title-text {
  color: #2c3e50;
}
.ai-sec {
  padding: 60px 0px 60px;
}
.fileGroup {
  display: flex;
  justify-content: space-around;
  height: 350px;
}

.imgBottom {
  position: absolute;
  bottom: 0;
}

.fileGroup > div {
  width: 48%;
  position: relative;
}
@media screen and (max-width: 480px) {
  .fileGroup {
    flex-wrap: wrap;
    height: auto;
  }
  .fileGroup > div {
    width: 100%;
    position: relative;
  }
  .json_right {
    height: 300px;
  }
}

.fileGroup .json_right {
  border: 1px solid lightgray;
  height: 300px;
  overflow-y: scroll;
}

.fileGroup .imgShow {
  width: 100%;
  height: 300px;
  border: 1px solid lightgray;
    position: relative;
}
.fileGroup .imgShow img {
  /* width: 100%; */
  height: 100%;
}
.fileGroup .json_right {
  background: aliceblue;
}
#file0,
#file1,
#file2,
#file3,
#file4,
#file5,
#file6,
#file7 {
  display: none;
}
.responseTips {
  padding-top: 30px;
  text-align: left;
  padding-left: 20px;
  word-break: break-all;
}
.fileGroup .tips {
  position: absolute;
  left: 0;
  top: 0;
  padding: 5px 10px;
  background-color: #e6fafd;
  font-size: 14px;
  color: gray;
}
.btn-group {
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.imgSec {
  width: 100%;
  height: 100%;
  overflow: hidden;
  list-style-type: none;
  position: relative;
}
.compare {
  width: 20%;
  margin-top: 30px;
}
.rt60 {
  position: relative;
  top: -60px;
  margin-bottom: -60px;
}
.imgGroup {
  margin-bottom: 20px;
}
.imgGroup img {
  cursor: pointer;
}
@media screen and (max-width: 1366px) {
  .mainTop {
    height: 440px;
  }
}
@media screen and (max-width: 480px) {
  /* .mainTop {
    height: 650px !important;
  } */
}
.imgline {
  position: absolute;
  height: calc(100% - 2px);
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 255, 51, 0) 43%, #03a9f4 211%);
  border-bottom: 2px solid #03a9f4;
  transform: translateY(-100%);
  animation: radar-beam 1.5s infinite;
  animation-timing-function: cubic-bezier(0.3, 0, 0.43, 0.7);
  animation-delay: 0s;
  z-index: 11;
}
@keyframes radar-beam {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
